/**
 * COMPONENT REGISTRY
 * 
 * Maps component key strings (stored in IntelPost.component field in Django)
 * to React components. When a post has a `component` value, clicking
 * "Open Interactive" looks it up here and renders it in the slide panel.
 * 
 * To add new interactives:
 *   1. Create component in src/components/interactives/
 *   2. Register it here with a unique key
 *   3. Set that key on the post's `component` field via Django admin
 */

import React from "react";

const ContractAnalysis = React.lazy(() => import("../interactives/ContractAnalysis"));

const REGISTRY = {
  "contract-analysis": {
    Component: ContractAnalysis,
    title: "UFT Contract vs. Inflation — Interactive Analysis",
    description: "17-year interactive analysis with 5 chart views and 3 salary profiles",
  },
  // Future:
  // "salary-comparison": { Component: React.lazy(() => import("../interactives/SalaryComparison")), ... },
  // "retention-dashboard": { Component: React.lazy(() => import("../interactives/RetentionDashboard")), ... },
  // "pension-calculator": { Component: React.lazy(() => import("../interactives/PensionCalculator")), ... },
};

export function getRegisteredComponent(key) {
  return REGISTRY[key] || null;
}

export function hasRegisteredComponent(key) {
  return Boolean(key && REGISTRY[key]);
}

export default REGISTRY;
